import script from "./RulesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./RulesList.vue?vue&type=script&lang=ts&setup=true"

import "./RulesList.vue?vue&type=style&index=0&id=1d47f8aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d47f8aa"]])

export default __exports__